<template>
	<div>
		<send-mail-form :mail="mailForm" :window="false" params="{}" style="height: 600px; width: 70%;" />
	</div>
</template>

<script setup lang="ts">
	import {reactive, ref, onMounted} from 'vue';
	
	import SendMailForm from '@/vue/mail/SendMailForm.vue';
	import type { MailForm } from "@t/mail/MailForm";
	import {useNavigationStore} from "@/store/NavigationStore.ts";
	import {injectEnv} from "@fd/Environment";
	import {useRoute} from "vue-router";
	import {getIntAttParam} from "@/router/Router.ts";
	import {useVirtualRoute} from "@/router/virtual/VirtualRouter.ts";
	
	const mailForm = ref<MailForm>({mailIdent: 0});
	const env = injectEnv();
	const navStore = useNavigationStore();
	const route = useVirtualRoute();
	
	
	function initMailForm(): void {
		const id = route.query.id;
		const customer = route.query.customer;
		const branch = route.query.branch;
		const person = route.query.person;
		const busCase = route.query.busCase;
		const problem = route.query.problem;
		const opportunity = route.query.opportunity;
		const campaign = route.query.campaign;
		
		if (id) { mailForm.value.draft = id; }
		if (customer) { mailForm.value.customer = customer; }
		if (branch) { mailForm.value.branch = branch; }
		if (person) { mailForm.value.person = person; }
		if (busCase) { mailForm.value.busCase = busCase; }
		if (problem) { mailForm.value.problem = problem; }
		if (opportunity) { mailForm.value.opportunity = opportunity; }
		if (campaign) { mailForm.value.campaign = campaign; }
	}
	
	initMailForm();
	navStore.defineMenu((mb) => mb.standardMenu());

	onMounted(() => {
		navStore.forward(env.msg("menu.composeMail"));
	});
</script>